import * as Sentry from "@sentry/vue"
import posthog from "posthog-js/dist/module.full.no-external"
import Storage from "@/utils/storage"
import sessionToken from "@/utils/session-token"

const DEVICE_KEYS = ["device_id", "lang", "config"]

export async function purgeOfflineCopies() {
  try {
    const [registrations, cacheNames] = await Promise.all([
      navigator.serviceWorker?.getRegistrations() ?? [],
      window.caches?.keys() ?? [],
    ])
    await Promise.all([
      ...registrations.map((registration) => registration.unregister()),
      ...cacheNames.map((name) => caches.delete(name)),
    ])
  } catch (error) {
    Sentry.captureException(error)
  }
}

export async function removeUserKeys() {
  const keys = await Storage.keys()
  await Promise.all(keys.filter((key) => !DEVICE_KEYS.includes(key)).map((key) => Storage.remove(key)))
}

export async function clearSession() {
  posthog.reset()
  Sentry.setUser(null)
  await Promise.all([sessionToken.clear(), removeUserKeys(), purgeOfflineCopies()])
}
